/**
 * @description 获取域名
 * @returns {string}
 */
export const addressBarName = (): string => location.hostname
